import { InjectionToken } from '@angular/core';

export const PC_MOCK_API_DEFAULT_DELAY = new InjectionToken<number>('PC_MOCK_API_DEFAULT_DELAY');
